module.exports = "https://r.nearpod.com/assets/media/image/npp_quick_launch_rocket-c8d6dae17facac579692e1f5062f433b.svg";